import { Controller } from '@hotwired/stimulus';
import Axios from "../axios";

let availableModalControllers = [];

export default class extends Controller {

    connect() {
        availableModalControllers.push(this);

        const urlParams = new URLSearchParams(window.location.search);
        const modal = urlParams.get('modal');
        const modalID = this.element.dataset.id;
        if (modal && modal === modalID) {
            this.showModal();
        }

        this.modalScrollContainer = this.element.querySelector('.modal-scroll-container');
        this.modalDialogContainer = this.element.querySelector('.modal-dialog');
        this.modalContent = this.element.querySelector('.modal-content');

        for (const close of document.body.querySelectorAll('.modal-close')) {
            close.addEventListener('click', () => this.hideModal());
        }

        this.modalScrollContainer.addEventListener('mousedown', (e) => {
            if (e.target === this.modalScrollContainer) {
                this.hideModal();
            }
        });

        this.modalDialogContainer.addEventListener('mousedown', (e) => {
            if (e.target === this.modalDialogContainer) {
                this.hideModal();
            }
        });

        this.modalContent.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        this.bindModalOpenButtons();

        if (this.element.classList.contains('modal-auto-open')) {
            this.showModal();
        }
    }

    disconnect() {
        availableModalControllers = [];
    }

    bindModalOpenButtons() {
        for (const el of document.querySelectorAll(`[data-modal-open="${this.element.id}"]`)) {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const url = el.hasAttribute('data-modal-request') ? el.getAttribute('data-modal-request') : '';
                if (url && !this.modalRequestLoading) {
                    this.modalRequestContent(url);
                }
                const content = el.hasAttribute('data-modal-content') ? el.getAttribute('data-modal-content') : '';
                if (content) {
                    const modalContent = this.element.querySelector('.modal-body');
                    modalContent.innerHTML = content;
                    this.element.classList.add('clear-content-on-hide');
                }
                this.showModal();
            });
        }
    }

    async modalRequestContent(url) {
        this.modalRequestLoading = true;
        const modalContent = this.element.querySelector('.modal-body');
        modalContent.classList.add('loading');
        if (url) {
            let response = null;
            try {
                response = await Axios.get(url);
                response = response.data;
            } catch (error) {
                response = error.response.data;
            }
            if (response) {
                modalContent.innerHTML = response.data;
                modalContent.classList.remove('loading');
                this.bindModalOpenButtons();
            }
        }
        this.modalRequestLoading = false;
    }

    getOpenedModal() {
        for (const controller of availableModalControllers) {
            if (controller.element.classList.contains('modal-show')) {
                return controller;
            }
        }

        return null;
    }

    showModal(callback) {
        const currentModal = this.getOpenedModal();

        if (currentModal) {
            currentModal.hideModal(() => {
                this.showModalHandle(callback);
            });
        } else {
            this.showModalHandle(callback);
        }
    }

    showModalHandle(callback) {
        this.clearModalFormInputs();
        this.element.classList.add('modal-show');

        let op = 0.1;
        this.element.style.display = 'block';
        const timer = setInterval(() => {
            if (op >= 1) {
                clearInterval(timer);

                if (callback) {
                    callback();
                }
            }
            this.element.style.opacity = op;
            this.element.style.filter = `alpha(opacity=${op * 100})`;
            op += op * 0.1;
        }, 5);

        document.getElementsByTagName('html')[0].classList.add('modal-visible');
    }

    hideModal(callback) {
        this.element.classList.remove('modal-show');

        let op = 1;
        const timer = setInterval(() => {
            if (op <= 0.1) {
                clearInterval(timer);
                this.element.style.display = 'none';

                if (callback) {
                    callback();
                }
            }
            this.element.style.opacity = op;
            this.element.style.filter = `alpha(opacity=${op * 100})`;
            op -= op * 0.1;
        }, 5);

        document.getElementsByTagName('html')[0].classList.remove('modal-visible');

        this.element.dispatchEvent(new Event('modal-hide'));
    }

    clearModalFormInputs() {
        const forms = this.element.querySelectorAll('form');

        for (const form of forms) {
            const generalErrors = form.querySelectorAll('.general-error');
            for (const el of generalErrors) {
                el.remove();
            }

            const generalSuccess = form.querySelectorAll('.general-success');
            for (const el of generalSuccess) {
                el.remove();
            }

            const fields = form.querySelectorAll('.input');
            for (const el of fields) {
                el.classList.remove('invalid');

                if (el.classList.contains('clear-before') && !el.classList.contains('ignore-clear-before')) {
                    el.value = '';
                }

                if (el.hasAttribute('data-reset-to')) {
                    el.value = el.getAttribute('data-reset-to');
                }
            }

            const hiddenFields = form.querySelectorAll('.axios-hide');
            for (const el of hiddenFields) {
                el.classList.remove('hidden');
            }

            const messageFields = form.querySelectorAll('.input-error');
            for (const el of messageFields) {
                el.remove();
            }
        }
    }
}
